/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// useStrict
/* global aBoothClick, mBoothClick, rBoothClick  */
var simpleDrawing;

expocadfx.Floorplan = function() {
    //var eventDatabaseName = "19ces";
    var config = expocadfx.config;
    var data = expocadfx.fxData;
    var elemById = expocadfx.element.elementById;
    var txt = expocadfx.txt;
    var fxStyle = expocadfx.styles;
	var util = expocadfx.util;
    var Booth = expocadfx.Booth;
    var Drawing = expocadfx.Drawing;
    var Drawing3d = expocadfx.Drawing3d;
    var FxEvent = expocadfx.fxevent;
    var GraphicObject = expocadfx.GraphicObject;
    var MiniMap = expocadfx.MiniMap;
    
    var BOOTH_AVAILABLE = "0";
    var BOOTH_HOLD = "1";
    var BOOTH_RENTED = "2";
    var BOOTH_DELETED = "4";
    
    var twoD = null;
    var threeD = null;
	var drawing = null;
    var sales = null;
    var miniMap = null;
    var doc = document;
    
    var fpc = null;
    var flyout = null;
    var threedflyout = null;
    
    var touchStartTime = 0;
    var lastTapTime = 0;
    var lastTouchX = 0;
    var lastTouchY = 0;
    var dragging = false;       // panning
    var zooming = false;
    var bTextDone = false;
    var lastDist = -1;
    var pointerEvents = [];
    
    var fpcHeight = 0;
    var fpcWidth = 0;
    var zoomStep = 0.1;
    var bBuildingText = false;
    var bProcessPending = true;
    var totalElements = 0;
    var elementsDone = 0;
    var loopSize = 50;
    var clickCount = 0;
	var techLayersPending = false;
    
    var buildingImage = null;
    var xmlBooths = null;
    
    var bPointerDown = false;
    var lastBooth = null;

    var flyoutPending = false;
    var flyoutDelay = null;
    var fpRight = 0;
    var fpBottom = 0;

    var locationTimeoutID = 2;
    
	
	doc.addEventListener( "Technical_Layers_Loaded", techLayersLoaded);
    doc.addEventListener( "Wayfinder_Data_Loaded", wayfinderDataLoaded);
    
    function getDistance( touch1, touch2) {
        return Math.sqrt(Math.pow((touch2.clientX - touch1.clientX), 2) + 
                                         Math.pow((touch2.clientY - touch1.clientY), 2)); 
    }
    
    function getBoothColor( graphic, status) {
        //  Option to use EXPOCAD booth color for line or fill
        if (status === 0 || status === BOOTH_AVAILABLE) {
            graphic.fillColor = config.fillAvailableWithExpocadColor && graphic.expColor !== "" ?
                graphic.expColor : config.clrAvailable;
            
            graphic.strokeColor = config.borderAvailableWithExpocadColor && graphic.expColor !== "" ?
                graphic.expColor : config.clrBoothBorder !== "" ? 
                config.clrBoothBorder : config.bBoothGradient ?
                config.clrAvailable : config.clrBackground;
            
        } else if (status === 1 || status === BOOTH_HOLD) {
            graphic.fillColor = config.fillOnHoldWithExpocadColor && graphic.expColor !== "" ?
                graphic.expColor : config.clrHold;
            
            graphic.strokeColor = config.borderOnHoldWithExpocadColor && graphic.expColor !== "" ?
                graphic.expColor : config.clrBoothBorder !== "" ? 
                config.clrBoothBorder : config.bBoothGradient ?
                config.clrAvailable : config.clrBackground;
            
        } else if (status === 2 || status === BOOTH_RENTED) {
            graphic.fillColor = config.fillRentedWithExpocadColor && graphic.expColor !== "" ?
                graphic.expColor : config.clrRent;
            
            graphic.strokeColor = config.borderRentedWithExpocadColor && graphic.expColor !== "" ?
                graphic.expColor : config.clrBoothBorder !== "" ? 
                config.clrBoothBorder : config.bBoothGradient ?
                config.clrAvailable : config.clrBackground;
            
        } else {    // ?? what is it ??
            graphic.fillColor = "white";
            graphic.strokeColor = "white";
        }
    }
    
    function getBoothMinMax( graphic) {
        var i = 0;
        graphic.minX = graphic.path[0].x;
        graphic.minY = graphic.path[0].y;
        graphic.maxX = graphic.path[0].x;
        graphic.maxY = graphic.path[0].y;

        for( i = 1; i < graphic.numPoints; i++) {
            graphic.minX = (graphic.path[i].x < graphic.minX) ? graphic.path[i].x : graphic.minX;
            graphic.minY = (graphic.path[i].y < graphic.minY) ? graphic.path[i].y : graphic.minY;
            graphic.maxX = (graphic.path[i].x > graphic.maxX) ? graphic.path[i].x : graphic.maxX;
            graphic.maxY = (graphic.path[i].y > graphic.maxY) ? graphic.path[i].y : graphic.maxY;
        }
            // probable bad show, BUT 2011 CES had 10 "booths" with 4 identical points
            //    3d throws exception!
        if( graphic.minX === graphic.maxX || graphic.minY === graphic.maxY) {
            graphic.hasSize = false;
        }
    }
    
    function newBooth( boothNumber) {
        var booth = new Booth( null, data.booths.length);
        booth.number = boothNumber;
        booth.graphic = new GraphicObject( null, "T");
        booth.graphic.index = data.booths.length;
        booth.graphic.fill = true;
        booth.graphic.stroke = true;
        booth.graphic.alpha = config.BOOTH_ALPHA;
        
        getBoothColor( booth.graphic, BOOTH_AVAILABLE);
        
        data.booths.push( booth);
        data.boothGraphics.push( booth.graphic);
        
        return booth;
    }
    
    function saveNewBooth( booth) {
        data.booths.push( booth);
        data.boothGraphics.push( booth.graphic);
    }
    
    function parseGraphicsXml( xml, start) {
        var end = (start + loopSize < totalElements) ? start +loopSize: totalElements;
        
        var i = 0;
        var booth = null;
        var graphic = null;
        var type = "";
		var arc = null;
        
        for( i = start; i < end; i++) {
            //  all graphic objects - booths, pavilions, graphics
            type = xml[i].getAttribute("b");
			
			if( type === "C") {
				data.arCircles.push( makeCircle( xml[i], type));
			}
			else if( type === "A") {
				arc = makeCircle( xml[i], type);
				arc.startAngle = parseFloat( xml[i].getAttribute( "s"));
				arc.endAngle = parseFloat( xml[i].getAttribute( "e"));
				data.arArcs.push( arc);
			}
			else {
				graphic = new GraphicObject( xml[i], type);

				if( type !== "T") {
					drawing.addGraphic(graphic);
				}
				else {
					getBoothMinMax( graphic);
					booth = new Booth( xml[i], data.booths.length);
					if( booth.status === BOOTH_AVAILABLE) {
						data.numAvailableBooths += 1;
					}
					else if( booth.status === BOOTH_HOLD) {
						data.numOnHoldBooths += 1;
					}
					getBoothColor( graphic, booth.status);
					graphic.displayColor = graphic.fillColor;
					booth.graphic = graphic;

					graphic.index = booth.index;

					data.booths.push( booth);
						// 2D or 3D
					drawing.addBoothGraphic( graphic);
					data.boothGraphics.push( graphic);
				}
			}
		}
    }
	
	function makeCircle( xml, type) {
		return {
			type: type,
			x: parseInt( xml.getAttribute( "x"), 10),
			y: parseInt( xml.getAttribute( "y"), 10),
			radius: parseFloat( xml.getAttribute( "r")),
			startAngle: 0,
			endAngle: 2 * Math.PI,
			lineWidth: 2 * parseInt( xml.getAttribute( "w"), 10),
			strokeColor: xml.getAttribute( "c").replace( "0x", "#"),
			alpha: 1,
			anticlockwise: false
		};
    }
    
    function makeJsonCircle( json, type) {
		return {
			type: type,
			x: parseInt( json.x, 10),
			y: parseInt( json.y, 10),
			radius: parseFloat( json.r),
			startAngle: 0,
			endAngle: 2 * Math.PI,
			lineWidth: 2 * parseInt( json.w, 10),
			strokeColor: json.colorOverride,
			alpha: 1,
			anticlockwise: false
		};
	}
    
    function removeBoothText( bth) {
		var exhId = data.exhibitors[bth.exhibitorIndex].exhId;
        drawing.removeBoothText( bth);
		
		doc.dispatchEvent( new FxEvent( "Favorite_Change", { fav:false, 
															boothNumber:bth.number,
															boothIndex:bth.index,
															exhId:exhId,
															local:true
															}));
		doc.dispatchEvent( new FxEvent( "Booth_List_Change", {}));
    }
    
	function createFloorPlanObjects() {
		if( buildingImage === null) {
			getBuildingImage( config.eventName);
		}
        if( elementsDone < totalElements) {
            if( config.isXML){
                parseGraphicsXml( xmlBooths, elementsDone);
            }
            elementsDone += loopSize;
			loopSize += 100;		// shorter initial loop allows building jpeg to start loading sooner
        }
        else if( !bTextDone) {      // Pavilion name and any other non-booth text(?)
            
            if( config.isXML){
                addText( data.xmlGraphics.querySelectorAll( "PT"), data.pavilionLabels,
                    config.clrBoothText, config.FLOOR_PLAN_FONT);

                addText( data.xmlGraphics.querySelectorAll( "OT"), data.floorPlanText,
                    config.clrBoothText, config.FLOOR_PLAN_FONT);
            }
            else{
                parseGraphicsSQL();
            }
        
            bTextDone = true;
        }
        else if( !bBuildingText) {
			if( data.xmlBldgTxt && config.isXML) {
				addText( data.xmlBldgTxt, data.buildingText,
							config.clrBuildingText, config.FLOOR_PLAN_FONT);
				
				bBuildingText = true;
				data.status.buildingTextReady = true;
				bProcessPending = false;
				data.xmlBldgTxt = null;
            }
            else if( data.jsonBldgTxt){
                addJsonText( data.jsonBldgTxt, data.buildingText,
                    config.clrBuildingText, config.FLOOR_PLAN_FONT);
                
                bBuildingText = true;
                data.status.buildingTextReady = true;
                bProcessPending = false;
                data.jsonBldgTxt = null;
            }
        }
        
        if( bProcessPending) {
            setTimeout( createFloorPlanObjects, 0);
            drawing.redraw();
        }
        else {
            data.xmlGraphics = null;
            xmlBooths = null;
            
            enableEvents();
            data.status.boothObjectsReady = true;
            
            if( miniMap) {
                miniMap.setup();
            }
            drawing.completeSetup();
            elemById( "load").style.opacity = 0;
			
			if( techLayersPending) {
				processTechLayers();
			}
        }
    }
    
        // IN PROGRESS...
        function parseGraphicsSQL() {
            
            var BOOTH_COORDS = jsonGraphics.booths;
            var pavilions = jsonGraphics.pavilions;

            var i = 0;
            var booth = null;
            var graphic = null;
            var type = "";
            var arc = null;
    
            // Booths
            for (var i = 0; i < BOOTH_COORDS.length; i++) {

                type = 'T';
                graphic = new GraphicObject(null, type, BOOTH_COORDS[i]);
                getBoothMinMax(graphic);
    
                booth = new Booth(null, data.booths.length, BOOTH_COORDS[i]);
                if( booth.status === BOOTH_AVAILABLE) {
                    data.numAvailableBooths += 1;
                }
                else if( booth.status === BOOTH_HOLD) {
                    data.numOnHoldBooths += 1;
                }
                
                getBoothColor( graphic, booth.status);
                graphic.displayColor = graphic.fillColor;
                //graphic.displayColor = "#ADD8E6"; //Hard coded blue
                booth.graphic = graphic;
                graphic.index = booth.index;
                data.booths.push(booth);
                // 2D or 3D
                drawing.addBoothGraphic(graphic);
                data.boothGraphics.push(graphic);
            }

            i = 0;

            // Pavilions
            for (var i=0; i < pavilions.length; i++){
                
                type = 'P';
                graphic = new GraphicObject( null, type, pavilions[i]);
                drawing.addGraphic(graphic);

                addJsonText(pavilions[i].textItems, data.pavilionLabels,
                    config.clrBoothText, config.FLOOR_PLAN_FONT);
            }


            // Additional Graphics? - may have been moved to technical layers..
            // if( type === "C") {
			// 	data.arCircles.push( makeCircle( xml[i], type));
			// }
			// else if( type === "A") {
			// 	arc = makeCircle( xml[i], type);
			// 	arc.startAngle = parseFloat( xml[i].getAttribute( "s"));
			// 	arc.endAngle = parseFloat( xml[i].getAttribute( "e"));
			// 	data.arArcs.push( arc);
			// }
			// else {
			// 	graphic = new GraphicObject( xml[i], type);

			// 	if( type !== "T") {
			// 		drawing.addGraphic(graphic);
            //     }
            // }

            // Clear graphics from memory 
            //jsonGraphics = null;


            // TEMP 
        // var end = (start + loopSize < totalElements) ? start +loopSize: totalElements;
        
        // var i = 0;
        // var booth = null;
        // var graphic = null;
        // var type = "";
		// var arc = null;
        
        // for( i = start; i < end; i++) {
        //     //  all graphic objects - booths, pavilions, graphics
        //     type = xml[i].getAttribute("b");
			
		// 	if( type === "C") {
		// 		data.arCircles.push( makeCircle( xml[i], type));
		// 	}
		// 	else if( type === "A") {
		// 		arc = makeCircle( xml[i], type);
		// 		arc.startAngle = parseFloat( xml[i].getAttribute( "s"));
		// 		arc.endAngle = parseFloat( xml[i].getAttribute( "e"));
		// 		data.arArcs.push( arc);
		// 	}
		// 	else {
		// 		graphic = new GraphicObject( xml[i], type);

		// 		if( type !== "T") {
		// 			drawing.addGraphic(graphic);
		// 		}
		// 		else {
		// 			getBoothMinMax( graphic);
		// 			booth = new Booth( xml[i], data.booths.length);
		// 			if( booth.status === BOOTH_AVAILABLE) {
		// 				data.numAvailableBooths += 1;
		// 			}
		// 			else if( booth.status === BOOTH_HOLD) {
		// 				data.numOnHoldBooths += 1;
		// 			}
		// 			getBoothColor( graphic, booth.status);
		// 			graphic.displayColor = graphic.fillColor;
		// 			booth.graphic = graphic;

		// 			graphic.index = booth.index;

		// 			data.booths.push( booth);
		// 				// 2D or 3D
		// 			drawing.addBoothGraphic( graphic);
		// 			data.boothGraphics.push( graphic);
		// 		}
		// 	}
		// }
        }
    
    
    function addText( xml, arr, color, fontFamily) {
        var i = 0;
        var numText = xml.length;
        for( i = 0; i < numText; i++) {
            arr.push( util.textFromXML( xml[i], color, fontFamily));
        }
    }

    function addJsonText( jsonObject, arr, color, fontFamily, isAddText) {
        var i = 0;
        var numText = jsonObject.length;

        for( i = 0; i < numText; i++) {
            if(isAddText){
                color = jsonObject[i].color;
            }

            arr.push( util.textFromJSON( jsonObject[i], color, fontFamily));
        }
    }
    
    function getBuildingImage( eventName) {
        if( data.notOldios) {
            buildingImage = doc.createElement( "img");

            if( config.isXML){
                buildingImage.src = (config.hasMultipleViews && config.hasFloorPlan) ?
                    config.viewName + ".jpg" : eventName + ".jpg";
            }
            else{
                buildingImage.src = (config.hasMultipleViews && config.hasFloorPlan && config.apiView != "") ?
                    config.apiView + ".png" : eventDatabaseName + ".png";
            }

            buildingImage.onload = function() {
                drawing.addBuilding( buildingImage);
                if( miniMap) {
                    miniMap.addBuilding( buildingImage);
                }
            };
        }
    }

    function wayfinderDataLoaded() {
        doc.removeEventListener( "Wayfinder_Data_Loaded", techLayersLoaded);
            // Parse and store the data in these variables
            var X = data.wayData.querySelectorAll('X')[0];
            var Y = data.wayData.querySelectorAll('Y')[0];
            
            data.boardNumXPoints = X.getAttribute("num");
            data.boardNumYPoints = Y.getAttribute("num");
            data.boardXValues = X.querySelectorAll("V")[0].getAttribute("values").split(",");
            data.boardYValues = Y.querySelectorAll("V")[0].getAttribute("values").split(",");
            data.board = data.wayData.querySelectorAll('B')[0].getAttribute("bp").split(",");
            data.board = data.board.map(Number);
    }
	
	function techLayersLoaded() {
		doc.removeEventListener( "Technical_Layers_Loaded", techLayersLoaded);
		if( data.status.boothObjectsReady) {
			processTechLayers();
		}
		else {
			techLayersPending = true;
		}
	}
	
	function processTechLayers() {
        if ( config.isXML) {
            var xmlGroups = data.xmlTechLayers.querySelectorAll( "Group");
            var xmlGraphics = null;
            var newGroup = null;
            var addGraphic = null;
            var len = xmlGroups.length;
            var i = 0;
            // technical layers
            for( i = 0; i < len; i++) {
                
                newGroup = {
                    id: i,
                    name: xmlGroups[i].getAttribute( "n"),
                    visible: xmlGroups[i].getAttribute("o") === "1" ? true : false,
                    graphics: [],
                    txt: []
                };
                
                xmlGraphics = xmlGroups[i].querySelectorAll( "S");
                
                xmlToObjects( xmlGraphics, newGroup);
                
                addText( xmlGroups[i].querySelectorAll( "OT"), newGroup.txt,
                                config.clrBuildingText, config.FLOOR_PLAN_FONT);

                data.arTechLayers.push( newGroup);
            }
            // user added graphics
            addGraphic = data.xmlTechLayers.querySelector( "AddGraph");
            if( addGraphic && addGraphic.childElementCount > 0) {
                data.addedGraphics = {
                    graphics: [],
                    txt: []
                };
                
                xmlGraphics = addGraphic.querySelectorAll( "S");
                
                xmlToObjects( xmlGraphics, data.addedGraphics);
                
                addText( addGraphic.querySelectorAll( "OT"), data.addedGraphics.txt,
                                config.clrBoothText, config.FLOOR_PLAN_FONT);
            }
        }
        else {
            var jsonGroups = data.jsonTechLayers;
            var jsonGraphics = null;
            var jsonLayerGraphics = null;
            var newGroup = null;
            var addGraphic = null;
            var len = jsonGroups.length;
            var i = 0;
            // technical layers
            for( i = 0; i < len; i++) {
                newGroup = {
                    id: i,
                    name: jsonGroups[i].n, //.name?
                    visible: jsonGroups[i].o === "1" ? true: false,
                    graphics: [],
                    txt: []
                };
        
        jsonLayerGraphics = jsonGroups[i].graphics;
        
        jsonToObjects( jsonLayerGraphics, newGroup);

        addJsonText( jsonGroups[i].texts, newGroup.txt,
                        config.clrBuildingText, config.FLOOR_PLAN_FONT);

        data.arTechLayers.push( newGroup);
    }
    // user added graphics
    addGraphic = data.jsonGraphics;
    if( addGraphic && (data.jsonGraphics.graphics.length > 0 || data.jsonGraphics.texts.length > 0)) {
        data.addedGraphics = {
            graphics: [],
            txt: []
        };
        
        jsonGraphics = addGraphic.graphics;
        
        jsonToObjects( jsonGraphics, data.addedGraphics);
        
        addJsonText( addGraphic.texts, data.addedGraphics.txt,
                        config.clrBoothText, config.FLOOR_PLAN_FONT, true);
    }
}		
		drawing.redraw();
		doc.dispatchEvent( new FxEvent( "Technical_Layer_Ready", null));
	}
	
	function xmlToObjects( xmlGraphics, obj) {
		var type = "";
		var newGraphic = null;
		var len = xmlGraphics.length;
		var i = 0;
		
		for( i = 0; i < len; i++) {
			// path, arc, circle  
			type = xmlGraphics[i].getAttribute("b");

			if( type === "C") {
				newGraphic = makeCircle( xmlGraphics[i], type);
				newGraphic.lineWidth = config.additionalGraphicsLineWidth;
				obj.graphics.push( newGraphic);
			}
			else if( type === "A") {
				newGraphic = makeCircle( xmlGraphics[i], type);
				newGraphic.startAngle = parseFloat( xmlGraphics[i].getAttribute( "s"));
				newGraphic.endAngle = parseFloat( xmlGraphics[i].getAttribute( "e"));
				newGraphic.lineWidth = config.additionalGraphicsLineWidth;
				obj.graphics.push( newGraphic);
			}
			else {
				newGraphic = new GraphicObject( xmlGraphics[i], "F");
				newGraphic.lineWidth = config.additionalGraphicsLineWidth;
				obj.graphics.push( newGraphic);
			}
		}
    }
    
    function jsonToObjects( jsonGraphics, obj) {
		var type = "";
		var newGraphic = null;
		var len = jsonGraphics.length;
		var i = 0;
		
		for( i = 0; i < len; i++) {
            
            // Only include booth layout objects if in Contractor mode
            if( jsonGraphics[i].bl > 0 ){
                if( config.salesMode !== "contra"){
                    continue;
                }
            }
            
            // path, arc, circle  
			type = jsonGraphics[i].b;

			if( type === "C") {
				newGraphic = makeJsonCircle( jsonGraphics[i], type);
				newGraphic.lineWidth = jsonGraphics[i].w; //config.additionalGraphicsLineWidth;
				obj.graphics.push( newGraphic);
			}
			else if( type === "A") {
				newGraphic = makeJsonCircle( jsonGraphics[i], type);
				newGraphic.startAngle = parseFloat( jsonGraphics[i].s);
				newGraphic.endAngle = parseFloat( jsonGraphics[i].e);
				newGraphic.lineWidth = jsonGraphics[i].w; //config.additionalGraphicsLineWidth;
				obj.graphics.push( newGraphic);
			}
            else if ( type === "T") {
                newGraphic = new GraphicObject( null, "T", jsonGraphics[i]);
				newGraphic.lineWidth = jsonGraphics[i].w; //config.additionalGraphicsLineWidth;
				obj.graphics.push( newGraphic);
            }
			else {
				newGraphic = new GraphicObject( null, "F", jsonGraphics[i]);
				newGraphic.lineWidth = jsonGraphics[i].w; //config.additionalGraphicsLineWidth;
				obj.graphics.push( newGraphic);
			}
		}
	}
	
    function zoomToBoothIndex( str, markBooth) {
        var arBooths = String(str).split( ",");
        var bthGraphic = null;
        var i = 0;
        var minX = config.DRAWING_WIDTH;
        var minY = config.DRAWING_HEIGHT;
        var maxX = 0;
        var maxY = 0;
		var newScale = 0;
		
		var margin = 0.2 * config.DRAWING_HEIGHT;	// maximum space around selected
		
		var selectedWidth = 0;
		var selectedHeight = 0;
		var selectedX = 0;
		var selectedY = 0;
        
        var canvas = document.getElementsByTagName('canvas')[3]
        var ctx = canvas.getContext('2d');
       // var radius = 70;
  
		
        if( arBooths.length > 0) {
            for( i = 0; i < arBooths.length; i++) {
                bthGraphic = data.boothGraphics[arBooths[i]];
                minX = Math.min( minX, bthGraphic.minX);
                minY = Math.min( minY, bthGraphic.minY);
                
                maxX = Math.max( maxX, bthGraphic.maxX);
                maxY = Math.max( maxY, bthGraphic.maxY);
                
                if( markBooth) {
                    drawing.markSelected( bthGraphic);
                }
            }
            
			selectedWidth = Math.max( maxX - minX, config.MULTIPLIER * config.scaleFactor);
			selectedHeight = Math.max( maxY - minY, config.MULTIPLIER * config.scaleFactor);
			
			margin = 2 * Math.min( Math.max( selectedWidth, selectedHeight), margin);
			
            //  ****  zoom less if one (great) big booth ??!!
            newScale = Math.min( fpcWidth / ( selectedWidth + margin), 
                                fpcHeight / ( selectedHeight + margin) );
                                                    
            selectedX = Math.round((maxX + minX) / 2);
            selectedY = Math.round((maxY + minY) / 2);

         //   ctx.beginPath();
      //      ctx.arc(selectedX, selectedY, radius, 0, 2 * Math.PI, false);
        //    ctx.fillStyle = 'green';
        //    ctx.fill();
        //    ctx.lineWidth = 500;
      //      ctx.strokeStyle = '#003300';
        //    ctx.stroke();   
            
            drawing.goToPoint( selectedX, selectedY, newScale);
        }
    }
    
    function zoomToIAmHere( x, y, label) {   // only at open event - center is middle of floor plan!
        var scale = drawing.getScale();
        var cax = parseInt( x, 10);
        var cay = parseInt( y, 10);
			// initial center of drawing
        drawing.moveBy( (config.DRAWING_WIDTH/2 - cax), ( config.DRAWING_HEIGHT/2 - cay));
        
        drawing.setIAmHere( String.fromCharCode(0xf140), label, x, y, config.clrHighlight);
        drawing.zoomTo( 0.6 - scale);
    }
    
    function tagBooth( boothIndex) {        //  Favorite   //
        if( twoD) {
            twoD.markFavorite( boothIndex);
        }
        if( threeD) {
            threeD.markFavorite( boothIndex);
        }
    }
    
    function clearBooth( type, boothIndex) {
        var arBoothIndex = String(boothIndex).split( ",");
        var i = 0;
        
        for( i = 0; i < arBoothIndex.length; i++) {
			if( twoD) {
				twoD.removeFavorite( arBoothIndex[i]);
			}
			if( threeD) {
				threeD.removeFavorite( arBoothIndex[i]);
			}
        }
    }
    
    function markFavorites() {
        var i = 0;
        var index = 0;
        var numFavs = data.favoriteBooths.length;
        var numBths = data.booths.length;
        
        for( i = 0; i < numFavs; i++) {
            for( index = 0; index < numBths; index++) {
                if( data.booths[ index].number === data.favoriteBooths[i].bth) {
                    drawing.markFavorite( index);
                    break;
                }
            }
        }
		if( drawing) {
			drawing.redraw( true);
		}
    }
    
    function outlineBooth( boothObj) {
        //  keep track of booths outlined ?
        drawing.addToOutline( boothObj, config.clrSelected, 12);
    }
    
    function unOutlineBooth( boothNum) {
        if( boothNum === null) {
            drawing.removeFromOutline( null);
        }
        else {
            var boothObj = util.findBoothObject( boothNum, data.booths);
            drawing.removeFromOutline( data.boothGraphics[ boothObj.index]);
        }
    }
    
    
 //-------------------------   EVENTS -----------------------------------------------------   
    function enableEvents() {
        if( config.bToolbar) {
            if( elemById("tb2") !== null) {
                    //  floor plan plus button
                elemById("tb2").addEventListener("click", function(){
                    drawing.zoom(2);
                });
                    // floor plan minus button
                elemById("tb3").addEventListener("click", function(){
                    drawing.zoom(-2);
                });
           }
                //   clear selected booths 
            doc.getElementById("tb4").addEventListener("click", function(){
                drawing.removeAllSelected();
            });

            doc.getElementById("tb5").addEventListener("click", fitDrawing);

            if( elemById("tb6") !== null) {
                doc.getElementById("tb6").addEventListener("click", function(){
            
                if( location.protocol === 'https:'){
                    if( config.locationEnabled){
                                        
                        config.locationEnabled = false;
                        elemById("tb6").style.backgroundColor = "#dcdcdc";

                        drawing.clearIAmHere();
                        drawing.redraw(true);

                        clearInterval(locationTimeoutID);
                    }
                    else{
                        getLocation();
                    }
                }
                else{
                        if(confirm("Location Services requires HTTPS.  Reload as secure site?")){
                            window.location.href ="https://" + location.hostname + location.pathname;
                        }
                    }

                });
            }
        }
        
        elemById( "floorplan").addEventListener( "wheel", wheelHandler);
        
        function wheelHandler(evt) {
            evt.stopImmediatePropagation();
            evt.preventDefault();

            if (evt.deltaY < 0){
               
               if( drawing != threeD){
                drawing.zoomToCursor( zoomStep);
               }
               else{
                drawing.zoom( zoomStep);
               }
                
            }
            else {
                if( drawing != threeD){
                    drawing.zoomToCursor( -1 * zoomStep);
                   }
                   else{
                    drawing.zoom( -1 * zoomStep);
                   }
            }
        }
        
        doc.addEventListener( "Highlight_Booth", function( evt) {
            drawing.highlightBooth( evt.data.index);
        });
        
        doc.addEventListener( "Unhighlight_Booth", function() {
            drawing.highlightBooth( "-1");
        });
        
		if( !data.status.overlaysReady) {
			doc.addEventListener( "overlaysLoaded", function() {
				twoD.addOverlays();
				if( threeD) {
					threeD.addOverlays();
				}
			});
		}
		
        fpc.addEventListener("contextmenu", function(e) { e.preventDefault(); });

        if ( window.PointerEvent) {
            fpc.addEventListener('pointerdown', function(evt) {
                var i = 0;
                evt.preventDefault();
                pointerEvents.push( evt);
                
                if( !dragging && !zooming && pointerEvents.length < 2) {
                   
                    for( i = 0; i < pointerEvents.length; i++) {
                        if( evt.pointerId === pointerEvents[i].pointerId) {
                            pointerEvents[i] = evt;
                        }
                    }
                    
                    if( pointerEvents.length === 1) {
                        lastTouchX = evt.clientX;
                        lastTouchY = evt.clientY;
                        touchStartTime = Date.now();
                        bPointerDown = true;
                        drawing.pointerDownAt( evt.clientX, evt.clientY);
                        
                        doc.dispatchEvent( new FxEvent( "User_Activity", null));
                    }
                    else {
                        lastDist = getDistance( pointerEvents[0], pointerEvents[1]);
                    }
                }
            });

            fpc.addEventListener('pointermove', pointerMoveHandler);
            
            fpc.addEventListener('pointerup', function(evt) {
                evt.preventDefault();
//                console.log( "pointer up button: " + evt.button);
                var i;
                for( i = 0; i < pointerEvents.length; i++) {
                     if( evt.pointerId === pointerEvents[i].pointerId) {
                        pointerEvents.splice( i, 1);
                         break;
                    }
                }
                
                if( pointerEvents.length < 2) {
                    lastDist = -1;
                }
                if( pointerEvents.length === 0) {
                    if( !dragging && !zooming && evt.button === 0 && Date.now() - touchStartTime < 400) {
                        tapHandler( lastTouchX, lastTouchY);
                    }
                    dragEndHandler();
                }
            });
            fpc.addEventListener('pointerout', function() {
                clearFlyoutAndHighlight();
                dragEndHandler();
                pointerEvents = [];
            });
            fpc.addEventListener('pointerleave', function() {
                clearFlyoutAndHighlight();
                dragEndHandler();
                pointerEvents = [];
            });
            fpc.addEventListener('pointercancel', function() {
                clearFlyoutAndHighlight();
                dragEndHandler();
                pointerEvents = [];
            });
            fpc.addEventListener('auxclick', function(evt) {
                if( evt.which === 2) {
                    fitClick(evt);
                }
            });
        }
        else {
            fpc.addEventListener('touchstart', function(evt) {
                evt.preventDefault();
                evt.stopImmediatePropagation();
                if( !dragging && !zooming) {
                    bPointerDown = true;
                    touchStartTime = Date.now();
                    
                    if( flyoutDelay) {
                        clearTimeout( flyoutDelay);     // does not remove booth highlight
                    }
                    if( evt.touches.length === 1) {
                        lastTouchX = evt.touches[0].clientX;
                        lastTouchY = evt.touches[0].clientY;
                        bPointerDown = true;
                        drawing.pointerDownAt( lastTouchX, lastTouchY);
                    }
                    else if( evt.touches.length > 1) {
                        lastDist = getDistance( evt.touches[0], evt.touches[1]);
                    }
                    fpc.addEventListener('touchmove', touchMoveHandler, false);
                }
                doc.dispatchEvent( new FxEvent( "User_Activity", null));
                return false;
            }, true);
            
            fpc.addEventListener('touchend', function(evt) {
                evt.preventDefault();
                evt.stopPropagation();
                evt.stopImmediatePropagation();
                
                fpc.removeEventListener('touchmove', touchMoveHandler, false);
                
                if( evt.touches.length === 0) {
                    if( !dragging && !zooming && Date.now() - touchStartTime < 400) {
                        tapHandler( lastTouchX, lastTouchY);
                    }
                    dragEndHandler();
                    lastDist = -1;
                }
            });
        
            if( data.device !== "ios" && data.device !== "A" ) {
                fpc.addEventListener('mousedown', function(evt) {
                    evt.preventDefault();
                    
                    if( evt.button === 0) {
                        lastTouchX = evt.clientX;
                        lastTouchY = evt.clientY;
                        bPointerDown = true;
                        drawing.pointerDownAt( evt.clientX, evt.clientY);
                        doc.dispatchEvent( new FxEvent( "User_Activity", null));
                    }
                });
                fpc.addEventListener('mouseup', function() {
                    dragEndHandler();
                });
                fpc.addEventListener('mousemove', function( evt) {
                    evt.preventDefault();
                    mouseMoveHandler( evt.clientX, evt.clientY);
                });
                fpc.addEventListener('mouseout', function() {
                    clearFlyoutAndHighlight();
                    dragEndHandler();
                });
                fpc.addEventListener('mouseleave', function() {
                    clearFlyoutAndHighlight();
                    dragEndHandler();
                });
                fpc.addEventListener( "click", function( evt) {
                    if( evt.button === 0) {
                        tapHandler( evt.clientX, evt.clientY);
                    }
                });
            }
		}  
    }
    
    function pointerMoveHandler( evt) {
        evt.preventDefault();
        var i;
        var currentDist = 0;
        
        if( pointerEvents.length === 0) {
            if( evt.pointerType === "mouse") {
                mouseMoveHandler( evt.clientX, evt.clientY);
            }
        }
        else {
            for( i = 0; i < pointerEvents.length; i++) {
                if( evt.pointerId === pointerEvents[i].pointerId) {
                    pointerEvents[i] = evt;
                }
            }
        }
        if( pointerEvents.length > 1) {
            currentDist = getDistance( pointerEvents[0], pointerEvents[1]);
            if( lastDist > 0) {
                pinchHandler( currentDist);
            }
            lastDist = currentDist;
        }
        else if( pointerEvents.length === 1) {
            mouseMoveHandler( evt.clientX, evt.clientY);
        }
    }
    
    function touchMoveHandler( evt) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        
        var touch1 = evt.touches[0];
        var touch2;
        
        if( evt.touches.length > 1) {
            touch2 = evt.touches[1];
            var dist = getDistance( touch1, touch2);
            
            if( lastDist > 0) {
                pinchHandler( dist);
            }
            lastDist = dist;
        }
        else if( evt.touches.length === 1) {
            dragHandler( touch1.clientX, touch1.clientY, false);
        }
        return false;
    }
    
    function pinchHandler( dist) {
        var change = dist - lastDist;
        
        if( change > 2 * window.devicePixelRatio) {  // and tm > 34mS
            lastTapTime = ( Date.now()) + 600;
            zooming = true;
            drawing.zoom( zoomStep);
        }
        else if( change < -2 * window.devicePixelRatio) {
            lastTapTime = ( Date.now()) + 600;
            zooming = true;
            drawing.zoom( -1 * zoomStep);
        }
        else {
            lastTapTime = Date.now();
            return;
        }
        lastDist = dist;
    }
    
    function dragEndHandler() {
        if( dragging) {
            dragging = false;
        }
        if( zooming) {
            zooming = false;
            drawing.redraw( true);
        }
        bPointerDown = false;
    }

    function fitClick(e){
            clickCount++;
            if (clickCount === 1) {
                singleClickTimer = setTimeout(function() {
                    clickCount = 0;
                }, 375);
            } else if (clickCount === 2) {
                clearTimeout(singleClickTimer);
                clickCount = 0;
                drawing.fit();
            }
    }
    
    function dragHandler( eventX, eventY) {
        var dx = 0;
        var dy = 0;
        if( zooming) {
            return; // Might be an issue when zoom to cursor is finished? 
        }
        if( bPointerDown) {
            dx = eventX - lastTouchX;
            dy = eventY - lastTouchY;
            
            if( dragging || Math.sqrt( dx * dx + dy * dy) > 5) {
                dragging = true;
                drawing.dragTo( eventX, eventY);
                lastTouchX = eventX;
                lastTouchY = eventY;
                
                lastTapTime = Date.now();
            }
        }
    }
    
    function tapHandler( eventX, eventY) {
        var ar = [];
        var tm = Date.now();
        var result = "1";
        var boothIndex = -1;
        var obj = null;
		
        var cursorX = eventX - elemById( "floorplan").offsetLeft;
        var cursorY = eventY - data.headerHeight;
           
        if( tm - lastTapTime < 340) {
            return;
        }
        lastTapTime = tm;
        if( flyoutPending) {
            clearTimeout( flyoutDelay);
            flyoutPending = false;
        }
//        console.log( "Floor Plan Tap Handler - menuPending: " + data.menuPending);
        if( data.menuPending || data.iahPending) {
			document.dispatchEvent( new FxEvent( "Floor_Plan_Tap", { pageX: cursorX, pageY: cursorY}) );
			if ( data.iahPending) {
                data.iahPending = false;
				return;
			}
        }
        
        obj = drawing.hitTest( cursorX, cursorY);
        if( obj !== null) {
			if (obj.hasOwnProperty("graphic")) {     // obj is a booth
				doc.dispatchEvent(new FxEvent("FloorplanBooth_Click", obj));//required for 3e analytics
                if( data.salesWindowOpen || data.wayPending) {
                    doc.dispatchEvent( new FxEvent( "Booth_Click", obj));
                }
                else {
                    if( config.bUseApi) {                            
                        if( obj.status === "0" || config.salesMode === "contra") {

                            if(config.salesMode === "exhibitor"){

                                doc.addEventListener( "Result_Booth_Lock_Status", boothLockHandler);
                                
                                result = 1; //stops popup when available booth is clicked
                            }
                            else if (config.salesMode === "contra"){
                                // Send contractor user to booth layout page
                                var boothUrl = doc.location.href.substr(0, doc.location.href.lastIndexOf("/"));
                                util.navigateTo( boothUrl + "/boothLayout?boothNumber=" + obj.number, "_parent" )

                                result = 0;
                            }
                            else{
                                result = aBoothClick( obj.number);
                            }
                            
 
                        }
                        else if(obj.status === "1" && config.salesMode === "exhibitor") { // Allow logged in exhibitor to select a booth on hold to them

                            if(config.loggedInExhib === data.exhibitors[obj.exhibitorIndex].exhId) {
                                // Need to include costs for hold booths though.. could suppress in flyout
                                //obj.cost = [{planName: "Regular Rate", cost: 3000}];
                                
                                doc.addEventListener( "Result_Booth_Lock_Status", boothLockHandler);
                                result = 1; //stops popup when available booth is clicked
                            }
                            else{
                                window.parent.swal("", "Booth Not Available For Rent!", "warning");
                                result = 0; //stops popup when available booth is clicked
                            }

                            
                        }
                        else {
                            ar = obj.exhibitorIndex.toString().split( ",");
                            if( ar.length > 1 && config.salesMode !== 'exhibitor') {
                                
                                if(config.exhibitorDirectory){
                                    doc.addEventListener( "Multi_Exhibitor_Click", MultiExhibitorClickHandler);
                                }
                                
                                result = mBoothClick( obj.number);
                            }
                            else {

                                if(config.salesMode === "exhibitor"){
                                    window.parent.swal("", "Booth Not Available For Rent!", "warning");
                                    result = 0; //stops popup when available booth is clicked
                                } 
                                else if(config.exhibitorDirectory){
                                        createModal();
                                        switchDirectoryDialog(data.exhibitors[obj.exhibitorIndex].exhId);
                                        result = 0; 
                                    
                                } 
                                else  {
                                    result = rBoothClick( obj.number,
                                                     data.exhibitors[obj.exhibitorIndex].exhId,
                                                     data.exhibitors[obj.exhibitorIndex].name);
                                    if( config.redirectToDirectory && !config.isXML){
                                        result = 0;
                                        util.navigateTo( doc.location.origin + data.exhibitors[obj.exhibitorIndex].directoryUrl);                          

                                    }
                                }
                            }
                        }
                    }
                    if( String(result) === "1") {
                        if( ar.length < 2 && data.exhibitors[obj.exhibitorIndex].url != "" && config.salesMode === "none") {
                            util.navigateTo( data.exhibitors[obj.exhibitorIndex].url);
                        }
                        else {
                            doc.dispatchEvent( new FxEvent( "Floor_Plan_Booth_Click", obj));
                        }
                    }
                }
            }
            else {  //  obj is an overlay
                    //  if navTo && zoomTo, zoom first and delay navigation to see the zoom
                    if( obj.navTo !== "") {
                        if( obj.zoomTo === "") {
                            util.navigateTo( obj.navTo);
                        }
                        else {
                            window.setTimeout( util.navigateTo, 700, obj.navTo);
                        }
                    }
                    
                    if( obj.zoomTo !== "") {
                        boothIndex = util.findBoothIndex( obj.zoomTo, data.booths);
                        if( boothIndex !== -1) {
                            zoomToBoothIndex( String(boothIndex), true);
                            
                        }
                    }
                    // else if( obj.navTo !== "") {
                    //     util.navigateTo( obj.navTo);
                    // }


            }
        }
    }

    function MultiExhibitorClickHandler(evt){
        createModal();
        switchDirectoryDialog(data.exhibitors[evt.data.selectedIndex].exhId);
    }

    function createModal(){
        if(!document.getElementById("buyModal")){
        var Parent = elemById('appContent');
        var Modal = doc.createElement('div');
        Modal.setAttribute("id", "buyModal");
        Modal.classList.add('modal');
        Parent.appendChild(Modal);
        var ModalContent = doc.createElement('div');
        ModalContent.classList.add('modal-content');
        Modal.appendChild(ModalContent);
        if(config.noNav){
            var ModalH3 = doc.createElement('h3');
            ModalContent.appendChild(ModalH3);
            ModalH3.textContent = "Rent This Booth?"

            var ModalPlan = doc.createElement('p');
            ModalPlan.setAttribute('id', 'ModalPlan');
            ModalContent.appendChild(ModalPlan);
        
            var ModalP = doc.createElement('p');
            ModalP.setAttribute('id', 'ModalP');
            ModalContent.appendChild(ModalP);

            var ModalFooter = doc.createElement('div');
            ModalFooter.setAttribute('id', 'modalFooter')
            ModalContent.appendChild(ModalFooter);

            var ModalContinue = doc.createElement('button');
            ModalContinue.setAttribute('id', 'modalContinue')
            ModalFooter.appendChild(ModalContinue);
            ModalContinue.textContent = "Rent Another";
            // Remove for now but eventually make dynamic based on booth selection limit
            ModalContinue.style.display = "none";

            var ModalCancel = doc.createElement('button');
            ModalCancel.setAttribute('id', 'modalCancel');
            ModalFooter.appendChild(ModalCancel);
            ModalCancel.textContent = "Cancel";
            
            var ModalConfirm = doc.createElement('button');
            ModalConfirm.setAttribute('id', 'modalConfirm')
            ModalFooter.appendChild(ModalConfirm);
            ModalConfirm.textContent = "Check Out";
        

        }
      }
    }

    function boothLockHandler(msg){
        obj = msg.data;

        if(config.salesMode === "exhibitor"){    
            var parent = document.querySelector('#floorplan')
            var cart = doc.createElement('div');            
            var legendFinish = doc.createElement('p');
            cart.setAttribute('id', 'cartLegend');
            cart.style.display = 'none';
            parent.insertAdjacentElement("afterend", cart)
            cart.innerHTML = "<i id='cartIcon'class='fas fa-shopping-cart'></i> Cart";
            legendFinish.setAttribute("id", "legendFinish");
            legendFinish.textContent = "Check Out";
            cart.appendChild(legendFinish);
        }
        if(config.salesMode === "exhibitor"){
            createModal();
        }
        
        if(config.showUnits === "M"){
            
            var area = obj.areaM;
            var dim = obj.dimM;
            }
            else
            {
                var area = obj.areaF;
                var dim = obj.dimF;
            }


            var boothLock = obj.locked; // Check for booth lock [EdgeApi/{databaseName}/fx/boothlocked]

            if(boothLock.viewRestricted || boothLock.siSRestricted ){
                window.parent.swal("", boothLock.message, "warning");

                return;
            }

            if (boothLock.lockStatus !== '0'){ 
                
                if (boothLock.lockStatus === '10'){
                    window.parent.swal("", "Booth is currently being purchased by another exhibitor.", "warning");
                }
                else if (Number(boothLock.Code) < 0) {
                    window.parent.swal("", "Something went wrong. Please contact show management or try selecting another booth.", "warning");
                }
                else {
                    window.parent.swal("", "Booth is currently being modified by Show Managment.", "warning");
                }
                
            }
            else {
                ExhibitorRentBooth(obj, obj.number, dim, area)
            }
    }

    var otherBooths = [];
    var total = 0;
    var displayCost = 'Select Rate';
    var selectedPlan = '';

    function addRateRadio(cost, container, costSpan){
        var ratePlanRadio = doc.createElement('div');
        ratePlanRadio.classList.add('form-check');

        var ratePlanLabel = doc.createElement('label');
        var ratePlanPrice = doc.createElement('label');
        ratePlanLabel.classList.add('form-check-label');
        ratePlanPrice.classList.add('form-check-label');
        ratePlanPrice.classList.add('float-right');
        ratePlanLabel.textContent = cost.planName;
        ratePlanPrice.textContent = util.displayUSD(cost.cost);

        var ratePlanInput = doc.createElement('input');
        ratePlanInput.classList.add('form-check-input');
        ratePlanInput.setAttribute('type', 'radio');
        ratePlanInput.setAttribute('name', 'ratePlan');
        ratePlanInput.setAttribute('value', cost.planName);
        ratePlanInput.onclick = function(){
            displayCost = util.displayUSD(cost.cost);
            costSpan.textContent = displayCost;
            elemById('modalContinue').disabled = false;
            elemById('modalConfirm').disabled = false;
            selectedPlan = document.querySelector('input[name="ratePlan"]:checked').value;
            console.log(document.querySelector('input[name="ratePlan"]:checked'))
        }
        ratePlanRadio.appendChild(ratePlanInput);
        ratePlanRadio.appendChild(ratePlanLabel);
        ratePlanRadio.appendChild(ratePlanPrice);
        container.appendChild(ratePlanRadio);
    }

    function resetModal(){
        //elemById('ratePlanDiv').remove();
        displayCost = 'Select Rate';
        selectedPlan = '';
        elemById('modalContinue').disabled = false;
        elemById('modalConfirm').disabled = false;


        document.querySelectorAll('.ratePlanDivClass').forEach(e => e.remove())
    }

    function ExhibitorRentBooth(theObj, objNum, dim, area){
        var modal = document.getElementById('buyModal');
        var modalBody = elemById('ModalP');
        var modalPPlan = elemById('ModalPlan');
        var confirmBut = elemById('modalConfirm');
        var cancelBut = elemById('modalCancel');
        var continueBut = elemById('modalContinue');
        var Next = parent.document.getElementById('theFloorplan');
        var NextDiv = parent.document.getElementById('CartBooths');
        var CartBooths = parent.document.createElement('div');
        var SelectedFP = parent.document.getElementsByClassName('overlay');
        var checkOut = elemById('legendFinish');
        var deleteSpan = doc.createElement('span');
        var cart = elemById('cartLegend');
        var legendite = doc.createElement('li');
        var legendSubTotal = doc.createElement('div');
        var ratePlan = doc.createElement('div');
        ratePlan.setAttribute('id', 'ratePlanDiv');
        var displayCostSpan = doc.createElement('span');
        legendSubTotal.setAttribute('id', 'legendSubTotalDiv');
        legendSubTotal.innerHTML = "<p>Subtotal: <span id='cartSubTotal'></span></p>";

        function calculateTotal(){
            total = 0;
            otherBooths.map(booth => {
                total = parseInt(booth.cost[0].cost) + parseInt(total)
             })
            if(otherBooths.length >= 2 && !elemById('cartSubTotal')){
                checkOut.appendChild(legendSubTotal); 
                elemById('cartSubTotal').textContent = util.displayUSD(total);
            } else if(otherBooths.length <= 1 && elemById('cartSubTotal')){
                doc.getElementById('legendSubTotalDiv').remove();
            } else {
                if(elemById('cartSubTotal')){
                    elemById('cartSubTotal').textContent = util.displayUSD(total);
                }
            }
        }
        deleteSpan.setAttribute("class", "deleteEvent");
        deleteSpan.textContent = "x";
        theObj.show = config.eventName;

        if(theObj.cost.length > 1){
            elemById('modalFooter').insertAdjacentElement('beforebegin', ratePlan);
            ratePlan.classList.add('mb-4');
            ratePlan.classList.add('ratePlanDivClass');
            continueBut.disabled = true;
            confirmBut.disabled = true;
            displayCostSpan.textContent = displayCost;

             theObj.cost.map(c => {
                addRateRadio(c, ratePlan, displayCostSpan);
             })
        } else {
            displayCost = util.displayUSD(theObj.cost[0].cost);
            displayCostSpan.textContent = displayCost;
        }
        modal.style.display = "block"; 
        modalPPlan.innerHTML = `${theObj.cost.length?theObj.cost[0].planName:''}`;
        modalPPlan.appendChild(displayCostSpan);
        modalBody.innerHTML = "Booth #" + objNum + " - " + dim + " " + area + ' for ';
        modalBody.appendChild(displayCostSpan);
        
        cancelBut.onclick = function() {
            modal.style.display = "none";
            resetModal()
        }
        confirmBut.onclick = function(){
            if(otherBooths.find(obj => obj.number === theObj.number)
            &&  otherBooths.find(obj => obj.show === theObj.show)
            || parent.Booths.find(obj => obj.number === theObj.number) 
            && parent.Booths.find(obj => obj.show === theObj.show)){
                parent.swal("", "Booth already in your cart!", "warning");
            } else {
            NextDiv.appendChild(CartBooths);
            otherBooths.push(theObj);
            CartBooths.setAttribute('class', 'CartBoothsInner');
            if(theObj.cost.length > 1){
                parent.AddBooth(theObj.number, theObj.show, function(ifMax){
                    if(ifMax){
                        checkOutClean()
                    } else {
                        resetModal()
                        modal.style.display = "none";
                    }
                }, selectedPlan);
            } else {
                parent.AddBooth(theObj.number, theObj.show, function(ifMax){
                    if(ifMax){
                        checkOutClean()
                    } else {
                        resetModal()
                        modal.style.display = "none";
                    }
                });
            }
        }
    }


        continueBut.onclick = function(){

            function updateLegend(ifMax){
                console.log(ifMax)
                if(ifMax){
                    var legendFinish = elemById('legendFinish');
                    cart.style.display = 'block';
    
                    legendite.textContent = "Booth " + objNum + ' - ' + util.displayUSD(theObj.cost[0].cost);
                    legendite.setAttribute('class', objNum + theObj.show);
                    cart.insertBefore(legendite, legendFinish);
                    legendite.insertAdjacentElement('beforeend', deleteSpan);
                    deleteSpan.onclick = function(e){
                        e.stopPropagation
                        parent.swal("Success", "Booth removed from Cart", "success");
                        this.parentNode.remove();
                        var found = otherBooths.find(obj => obj.number === objNum);
                        otherBooths.splice(otherBooths.indexOf(found), 1);
                        calculateTotal()
                        parent.removeBooth(theObj.number, theObj.show);
                        parent.document.querySelector("[class='" + theObj.number + theObj.show + "boothSubTimer']").remove();
                        parent.document.querySelector("[class='" + theObj.number + theObj.show + "boothSubTimer']").remove();
                    }
                    otherBooths.push(theObj);
                    calculateTotal()
                    var timerInterval = setInterval(function(){
                        var el = document.querySelector("[class='" + theObj.number + theObj.show + "']");
                        if(!document.body.contains(el)){
                            var found = otherBooths.find(obj => obj.number === theObj.number);
                            otherBooths.splice(otherBooths.indexOf(found), 1);
                            calculateTotal();
                            clearInterval(timerInterval);
                        }
                    }, 200);
                }
                modal.style.display = "none";
                document.getElementById('spinner').remove()
            }
            
            //ES6 syntax is being used. Namely .find() and arrow func
            if(otherBooths.find(obj => obj.number === theObj.number)
            &&  otherBooths.find(obj => obj.show === theObj.show)
            || parent.Booths.find(obj => obj.number === theObj.number) 
            && parent.Booths.find(obj => obj.show === theObj.show)){
                parent.swal("", "Booth Already in Your Cart!", "warning");
            } else {
                document.getElementById('ModalP').innerHTML = '<div id="spinner"></span>';
                if(theObj.cost.length > 1){
                    parent.AddBooth(theObj.number, theObj.show, updateLegend, selectedPlan);
                } else {
                    parent.AddBooth(theObj.number, theObj.show, updateLegend);
                }
            }
            resetModal();
        }

        function checkOutClean(){
            if (otherBooths !== undefined || otherBooths.length !== 0) {
                Array.prototype.push.apply(parent.Booths, otherBooths);
            }
            parent.singleShowAfterCheckout()
            for ( var i = 0; i < SelectedFP.length; i++ ) {
                SelectedFP[i].classList.remove( 'SelectedFloorplan' );
            }
            Next.style.boxShadow = "none";
            Next.setAttribute('src', '');
            NextDiv.style.display = "block";
        }

        checkOut.onclick = function(){
            NextDiv.appendChild(CartBooths);

            CartBooths.setAttribute('class', 'CartBoothsInner');
            
            if (otherBooths !== undefined || otherBooths.length !== 0) {
                Array.prototype.push.apply(parent.Booths, otherBooths);
            }
            for ( var i = 0; i < SelectedFP.length; i++ ) {
                SelectedFP[i].classList.remove( 'SelectedFloorplan' );
            }
            parent.singleShowAfterCheckout()
            Next.style.boxShadow = "none";
            Next.setAttribute('src', '');
            NextDiv.style.display = "block";
            resetModal()
        }
        window.onclick = function(event) {
        if (event.target == modal) {
            modal.style.display = "none";
            resetModal()
            }
        }
    }

    async function switchDirectoryDialog(exhib){
        var body = document.querySelector('.modal-content');
        var ModalFooter = doc.createElement('div');
        var ModalDesc = doc.createElement('div');
        var ModalName = doc.createElement('h4');;
        var ModalImage = doc.createElement('img');
        var ModalSub = doc.createElement('div');
        var ModalHeader = doc.createElement('div');
        var ModalSubHeaderLeft = doc.createElement('div');
        var ModalSubHeaderRight = doc.createElement('div');
        var ModalLogo = doc.createElement('div');
        ModalLogo.setAttribute('class', 'directoryLogoDetails')
        ModalName.setAttribute('class', 'my-3');
        ModalImage.setAttribute('class', 'modalImage');
        ModalSub.setAttribute('id', 'subModal');
        ModalSub.setAttribute('class', 'row');
        ModalHeader.setAttribute('class', 'row');
        ModalSubHeaderLeft.setAttribute('class', 'col-sm-4');
        ModalSubHeaderRight.setAttribute('class', 'col-sm-8 text-left');
        var parser = window.location
        var event = parser.pathname.split('/')[2];
        var modal = document.getElementById('buyModal');
        body.style.width = '960px';
        var ModalCancel = doc.createElement('button');
        ModalCancel.setAttribute('class', 'Xtop closeBtn directoryClose');
        ModalCancel.textContent = "X"
        var directoryDetailLink = `/${event}/Company/${exhib}`
  
        await fetch(`/${event}/Directory/Detail/${exhib}`).then(res => {
            if(!res.ok){
                swal('Something Went Wrong!', "Could not retrieve this exhibitor's information", 'error');
                return Promise.reject();
            }
            res.text().then(text => {
                var data;
                var banner;
                var backgroundSize = 'cover';
                try {
                    data = text && JSON.parse(text);
                    body.innerHTML = "";

                    if(data.directoryInfo.publicDirectoryBanner){
                        banner = data.directoryInfo.publicDirectoryBanner;
                    }
                    else if(data.directoryInfo.directoryBannerDefault){
                        banner = data.directoryInfo.directoryBannerDefault;
                    }
                    else{
                        //banner = 'https://actdev.expocad.com/' + event + '/webdrawing/thumb';
                        banner = 'https://i.imgur.com/hYOeclw.png';
                        backgroundSize = 'contain';
                    }
                    //ModalImage.setAttribute('src',`${config.hdrLogoSource ? `${config.hdrLogoSource}` : 'https://i.imgur.com/hYOeclw.png'}`);
                    ModalImage.style.background = `url(${banner})`
                    ModalImage.style.backgroundSize = backgroundSize;
                    ModalImage.style.border = `5px solid ${fxStyle.windowHeader.clrBg !== "" ? 
                    fxStyle.windowHeader.clrBg : fxStyle.mainHeader.clrBg}`
                    ModalName.textContent = data.exhibitorName;
                    ModalDesc.innerHTML = data.directoryInfo.directoryDescription;
                    ModalLogo.style.background = `url(${data.logoUrl ? `${data.logoUrl}` : 'https://i.imgur.com/hYOeclw.png'})`
                    ModalLogo.style.backgroundColor = 'white';
                    body.appendChild(ModalImage);
                    ModalSubHeaderRight.appendChild(ModalName);
                    ModalSubHeaderRight.appendChild(ModalDesc);
                    ModalSubHeaderLeft.appendChild(ModalLogo)
                    ModalSub.appendChild(ModalSubHeaderLeft)
                    ModalSub.appendChild(ModalSubHeaderRight)
                    body.appendChild(ModalSub)

                    generateInfo(data);

                    if(data.boothContacts.length){
                        generateContact(data.boothContacts, data.directoryInfo.products)
                    }

                    if(data.directoryInfo.products.length){
                        generateProducts(data.directoryInfo.products)
                    }
                    //addSharing(res.directoryInfo.facebookLink, res.directoryInfo.twitterLink, res.directoryInfo.linkedInLink, res.directoryInfo.addtnlSocialLinks)

                    modal.style.display = "block"; 
                    ModalFooter.setAttribute('id', 'modalFooter')

                    body.appendChild(ModalFooter);
                    addDetailLink(directoryDetailLink);
                    ModalFooter.appendChild(ModalCancel);
                    ModalCancel.onclick = function() {
                        elemById('buyModal').style.display = "none"    
                    }

					doc.dispatchEvent(new FxEvent("CompanyDetail_Open", data));//required for 3e analytics

                } catch (e) {
                    console.log(e)
                    swal('Something Went Wrong!', "Could not retrieve this exhibitor's information", 'error');
                }
            });
        })
    
        // .catch(() => {
        //     swal('Something Went Wrong!', "Could not retrieve this exhibitor's information", 'error');
        // })
    }

    function addDetailLink(link){
        var body = document.querySelector('.modal-content');
        var linkTag = document.createElement('a');
        linkTag.setAttribute('class', 'my-3');

        linkTag.setAttribute('href', link);
        linkTag.textContent = "Click Here to Visit Exhibitor's Detail page"

        //Open in new tab only if viewed from within our iframe
        if (config.noNav){
            linkTag.setAttribute('target', "new");
        }

        body.appendChild(linkTag);
    }

    function generateInfo(data){
        console.log(data)
        var body = document.querySelector('#subModal');
        var overallDiv = document.createElement('div');
        var bar = document.createElement('div')
        bar.setAttribute('class', 'col-sm-12 dialgLeft')
        overallDiv.setAttribute('class', 'row');
        var primaryInfo = document.createElement('div');
        var secondaryInfo = document.createElement('div');
        overallDiv.setAttribute('class', 'text-left mt-1 dialgLeft row col-sm-12');
        primaryInfo.setAttribute('id', 'primaryInfoDiv');
        primaryInfo.setAttribute('class', 'col-sm-6');
        secondaryInfo.setAttribute('id', 'secondaryInfoDiv');
        secondaryInfo.setAttribute('class', 'col-sm-6');
        bar.innerHTML = `<h4 id="hdrCnt" class="mt-3 divider" style="background-color: ${fxStyle.windowHeader.clrBg !== "" ? 
        fxStyle.windowHeader.clrBg : fxStyle.mainHeader.clrBg}; color:${fxStyle.windowHeader.clrText !== "" ? 
        fxStyle.windowHeader.clrText : fxStyle.mainHeader.clrText}; display: block;">Exhibitor Information</h4>`
        primaryInfo.innerHTML = 
        `<p><strong>Contact Name:</strong> ${data.salutation ? data.salutation : ''} ${data.contactName ? data.contactName : 'Not Specified'}</p>
        <p><strong>Address:</strong><br/> ${data.address1 ? data.address1 : 'Not Specified'}
            <a href="http://maps.google.com/maps?q=${data.address1},${data.city},${data.postCode}" target="_blank"><i class="fas fa-map-marker-alt"></i></a>
        ${data.address2 ? `<br/>${data.address2}` : ''}
        <br/>${data.city ? data.city : 'Not Specified'},
         ${data.state ? data.state : 'Not Specified'}
         ${data.postCode ? data.postCode : 'Not Specified'}
        <br/>${data.country ? data.country : 'Not Specified'}</p>`
         secondaryInfo.innerHTML = 
        `<p><strong>Title:</strong> ${data.title ? data.title : 'Not Specified'}</p>
        <p>${data.phone ? '<strong>Phone: </strong>' + data.phone : ''}
         ${data.fax ? '<strong> | Fax: </strong>' + data.fax : ''}
         ${data.cell ? '<strong> | Cell: </strong>' + data.cell : ''}</p>
         ${data.email ? '<p><strong>Email: </strong>' + data.email + ' <a href="mailto:' + data.email + '"><i class="fas fa-envelope"></i></a>' : ''}</p>
         ${data.website ? '<p><strong>Website: </strong> <a href="' + data.website + '" target="_blank">' + data.website + '</a>' : ''}</p>`

        body.appendChild(bar)
        overallDiv.appendChild(primaryInfo)
        overallDiv.appendChild(secondaryInfo)
        body.appendChild(overallDiv)
    }

    function generateProducts(products){
        var maxLength = 0;
        var body = document.querySelector('#subModal');
        var productOverallContainer = document.createElement('div');
        productOverallContainer.setAttribute('id', 'productContainer');
        productOverallContainer.setAttribute('class', 'col-sm-5');
        productOverallContainer.innerHTML = `<h4 id="hdrCnt" class="divider" style="background-color: ${fxStyle.windowHeader.clrBg !== "" ? 
        fxStyle.windowHeader.clrBg : fxStyle.mainHeader.clrBg}; color:${fxStyle.windowHeader.clrText !== "" ? 
        fxStyle.windowHeader.clrText : fxStyle.mainHeader.clrText}; display: block;">Products</h4>`
        products.map(p => {   
            if(maxLength < 2){     
                var productContainer = document.createElement('div');
                productContainer.setAttribute('class', 'detailProduct');
                console.log(p)
                productContainer.innerHTML = 
                `  <div class="row text-left">
                            <div class="col-sm-3">
                                <div id="productImageThumb${p.productId}"  class="productThumb productThumbMarg" style="background: url(${p.iconUrl});"></div>
                            </div>
                            <div class="col-sm-9">
                                <p><i class="fas fa-box-open"></i> <a class="productLink" href="${p.productLink}">${p.name}</a></p><p>
                                 </p><p>${p.shortDescription}</p><p>
                            </p></div>
                        </div>`
                productOverallContainer.appendChild(productContainer);
                maxLength++
            }            
        });
        body.appendChild(productOverallContainer)
    }
    function generateContact(contacts, prodLength){
        var body = document.querySelector('#subModal');
        var contactOverallContainer = document.createElement('div');
        contactOverallContainer.setAttribute('id', 'contactContainer');
        if(prodLength.length){
            contactOverallContainer.setAttribute('class', 'col-sm-7');
        } else {
            contactOverallContainer.setAttribute('class', 'col-sm-12');
        }
        contactOverallContainer.innerHTML = `<div class="col-sm-12"><h4 id="hdrCnt" class="divider" style="background-color: ${fxStyle.windowHeader.clrBg !== "" ? 
        fxStyle.windowHeader.clrBg : fxStyle.mainHeader.clrBg}; color:${fxStyle.windowHeader.clrText !== "" ? 
        fxStyle.windowHeader.clrText : fxStyle.mainHeader.clrText}; display: block;">Contacts</h4></div>`
        if(contacts[0]){
            var c = contacts[0];
                var contactContainer = document.createElement('div');
                contactContainer.innerHTML = 
            ` <div class="col-sm-12 text-left" id="exhibCenterBoothContacts">
            <div id="exhibContactId${c.id}" class="col-sm-12 detailContact detailProduct">
               <div class="row">
                   <div class="col-sm-8">
                       <p><i class="fas fa-user"></i> ${c.contactName}${c.title ? `, ${c.title}`: ''}</p>
                       ${c.phone ? `<p>${c.phone}</p>` : ''}
                       ${c.email ? `<p>${c.email}</p>` : ''}
                       <p>${c.address1 ? `${c.address1}` : ''} ${c.country ? `${c.country}`: ''} ${c.zip ? `${c.zip}` : ''}</p>
                   </div>
                   <div class="col-sm-3">
                      <div style="background-image: url(${c.avatarPhotoUrl ? c.avatarPhotoUrl : 'https://i.imgur.com/KUNLGER.png'})" class="boothContactAvatar"></div>
                   </div>
                       <div class="socialContacts col-sm-1">${c.facebookLink ? `<a target="_blank" href="${c.facebookLink}"><i class="fab fa-facebook"></i></a>`: ''}${c.twitterLink ? `<a target="_blank" href="${c.twitterLink}"><i class="fab fa-twitter"></i></a>`: ''}${c.linkedInLink ? `<a target="_blank" href="${c.linkedInLink}"><i class="fab fa-linkedin "></i></a>`: ''}</div>
                </div>
            </div>
           </div>`
                contactOverallContainer.appendChild(contactContainer);   
        }
        body.appendChild(contactOverallContainer)
    }
    
    function mouseMoveHandler( clientX, clientY) {
        var obj = null;
        var arExhIndex;
        var i;
        var flyoutText = "";
        var cursorX = clientX - elemById( "floorplan").offsetLeft;
        var cursorY = clientY - data.headerHeight;
        
        if( bPointerDown) {
            dragHandler( clientX, clientY);
        }
        else {
            
            // Avoid mouse interaction with booths when in simpleDrawing mode
            if( simpleDrawing == true){ return;}
            
            obj = drawing.hitTest( cursorX, cursorY);
            if( obj !== null) {
//                console.log( "Mouse move hit - obj: " + typeof(obj));
                if( obj === lastBooth) {
                    return;
                }
                if( obj.hasOwnProperty( "graphic")) {     // obj is a booth
                    drawing.highlightBooth( obj.index);
                    if( lastBooth === null || obj.number !== lastBooth.number) {
                        lastBooth = obj;
                        flyout.style.visibility = "hidden";
                        flyout.style.display = "block";

                        flyoutText = "<strong>" + txt.BOOTH + " &nbsp;";
                        flyoutText += obj.number + "</strong><br>";
                        var dimLabel = "Non-Rectangular";

                        if( config.units === "F") {
                            if( obj.dimF !== "" && obj.dimF !== null){
                                dimLabel = obj.dimF
                            }
                            else if (obj.areaF === "" || obj.areaF === null){
                                dimLabel = "";
                            }

                            flyoutText += dimLabel + "&nbsp;-&nbsp;" + obj.areaF + "<br>";
                        }
                        else {
                            if( obj.dimM !== "" && obj.dimF !== null){
                                dimLabel = obj.dimM
                            }
                            else if ( obj.areaM === "" || obj.areaM === null){
                                dimLabel = "";
                            }

                            flyoutText += dimLabel + "&nbsp;-&nbsp;" + obj.areaM + "<br>";
                        }
                        if( obj.status === "0") {
                            flyoutText += txt.AVAILABLE;
                            if( obj.flyout !== "" && obj.flyout !== null) {
                                flyoutText += "<br><em>" + obj.flyout + "</em>";
                            }
                            if(config.salesMode === "exhibitor"){
                                
                                for( i = 0; i < obj.cost.length; i++){
                                    
                                    if(obj.cost.length === 1){
                                        flyoutText += "<br>" + "Rate: " + obj.cost[0].planName;
                                        flyoutText += "<br>" + "Cost: " + util.displayUSD(obj.cost[0].cost);
                                    }
                                    else if (obj.cost.length > 1){
                                        flyoutText += "<br>" + obj.cost[i].planName + ": " + util.displayUSD(obj.cost[i].cost);
                                    }
                                    
                                }
                                
                            }
                        }
                        else {
                            arExhIndex = obj.exhibitorIndex.toString().split(",");
                            //arExhIndex = obj.exhibitorIndex[0];
                            for( i = 0; i < arExhIndex.length; i++) {
                                if( i > 0) {
                                    flyoutText += "<br>";
                                }
                                
                                flyoutText += data.exhibitors[ arExhIndex[i] ].name;
                                //flyoutText += data.exhibitors[arExhIndex].name;

                                if( !config.isXML){
                                    var companyLogo = data.exhibitors[ arExhIndex[i] ].companyLogo;

                                    if(companyLogo){
                                        flyoutText += '<br><img class="flyoutImg" src="' + companyLogo + '">';
                                    }
                                }
                            }
                        }
                        flyout.innerHTML = flyoutText;
                    }
                }
                else {      // obj is an overlay
                    if( obj.toolTip !== "") {
 
                        flyout.style.visibility = "hidden";
                        flyout.style.display = "block";
                        
                        flyout.innerHTML = obj.toolTip;
                    }
                }
                
                flyoutPending = true;
                clearTimeout( flyoutDelay);
                flyoutDelay = setTimeout( showFlyout, 320); // wait for tap
                
                flyout.style.left = ( clientX + flyout.offsetWidth + 20 < fpRight) ?
                                    (cursorX + 16) + "px" : 
                                    (cursorX - flyout.offsetWidth - 16) + "px";

                flyout.style.top = ( clientY + flyout.offsetHeight + 20 < fpBottom) ?
                                    (cursorY + 16) + "px" : 
                                    (cursorY - flyout.offsetHeight) + "px";

            }
            else {
                clearFlyoutAndHighlight();
            }
        }
    }
    
    function clearFlyoutAndHighlight() {
        if( lastBooth !== null) {
            drawing.highlightBooth( "-1");
        }
        clearTimeout( flyoutDelay);
        flyout.style.display = "none";
        flyout.innerHTML = "";
        lastBooth = null;
    }
    
    function showFlyout() {
        flyout.style.display = "block";
        flyout.style.visibility = "visible";
    }
    
    function init() {
        fpcHeight = elemById("floorplan").clientHeight;
        fpcWidth = elemById("floorplan").clientWidth;
        fpc = elemById( "fpContainer");
        flyout = elemById( "flyout"); 

        flyout.style.backgroundColor = config.clrFlyoutBackground || config.clrHighlight;
        flyout.style.color = config.clrFlyoutText || "#ffffff";
		if( config.flyoutFontSize) {
			flyout.style.fontSize = config.flyoutFontSize;
        }
        if( config.bToolbar && config.salesMode === "none" && config.elvis === false && config.is3d === true && !data.smallLayout){	    						
            threedflyout = document.querySelector('.flyout-3d');
            threedflyout.style.backgroundColor = config.clrFlyoutBackground || config.clrHighlight;
            threedflyout.style.color = config.clrFlyoutText || "#ffffff";
            threedflyout.style.fontSize = config.flyoutFontSize;
        }
		//  always create 2d environment or Chrome 64 cpu usage spikes on change from 3d to 2d !
		twoD = new Drawing();
		
		if( config.is3d && config.openIn3D) {
			threeD = new Drawing3d();
			drawing = threeD;
		}
		else {
			drawing = twoD;
		}
		
		drawing.showFloorPlan();
		
        if( data.miniMap) {
            miniMap = new MiniMap( data.miniMap.content, drawing.getOffset());
                miniMap.enableNavigation();
        }
        
        zoomStep = 1;
        
        if( config.isXML){
            xmlBooths = data.xmlGraphics.getElementsByTagName("S");
            totalElements = xmlBooths.length;
        }
        
        createFloorPlanObjects();
        
        if( config.showCoords) {
            elemById( "coords").style.display = "block";
        }
        if( fpRight === 0) {
            fpRight = data.viewportWidth - 2;
            fpBottom = data.viewportHeight - elemById( "ftr").offsetHeight;
        }
        
    }

    if(!config.isXML && !config.noNav && config.exhibitorDirectory){
         function navbar() {
            // bootstrap script
            var head = document.getElementsByTagName('head')[0];
            var bootScript = document.createElement('script');
            bootScript.type = 'text/javascript';
            bootScript.src = '../util/bootstrap.bundle.min.js';
            head.appendChild(bootScript)
            //-------------
            var nav = document.getElementById('dirNavbarNav');
            var loc = window.location;
            if(config.attendeeLogin) {
                var login = document.getElementById('directoryLogin');
            }
            var directory = document.createElement('button');
            var floorplan = document.createElement('button');
            var category = document.createElement('button');

            var directoryA = document.createElement('a');
            var floorplanA = document.createElement('a');
            var categoryA = document.createElement('a');

            var directoryListItem = document.createElement('li');
            var floorplanListItem = document.createElement('li');
            var categoryListItem = document.createElement('li');
    
            $(directory).addClass('directoryBtn');
            $(floorplan).addClass('floorplanBtn');
            $(category).addClass('categoryBtn');

            directoryA.appendChild(directory);
            floorplanA.appendChild(floorplan);
            categoryA.appendChild(category);

            directoryListItem.appendChild(directoryA);
            floorplanListItem.appendChild(floorplanA);
            categoryListItem.appendChild(categoryA);    

            directory.textContent = "Directory";
            floorplan.textContent = "Floorplan";
            category.textContent = "Categories";

            directory.classList.add("invertBtn");
            floorplan.classList.add("invertBtn");
            category.classList.add("invertBtn");

            directoryA.href = loc.protocol + "//" + loc.host + "/" + config.eventName + "/directory"
            categoryA.href= loc.protocol + "//" + loc.host + "/" + config.eventName + "/tags"
            if (config.attendeeLogin) {
                login.href= loc.protocol + "//" + loc.host + "/"
            }
            floorplan.disabled = true;

            nav.appendChild(directoryListItem);
            nav.appendChild(floorplanListItem)
            nav.appendChild(categoryListItem) 
            toggleFullScreen();
            setNavContent()
            function setNavContent() {
              $('.directoryBtn', nav).html('');
              $('.directoryBtn', nav).append(`<i class="fas fa-book-open"></i><span>Directory</span>`)
    
              $('.floorplanBtn', nav).html('');
              $('.floorplanBtn', nav).append(`<i class="fas fa-ruler"></i><span>Floorplan</span>`)
    
              $('.categoryBtn', nav).html('');
              $('.categoryBtn', nav).append(`<i class="fas fa-grip-horizontal"></i><span>Categories</span>`)
            
              $('.directoryBtn', nav).prop('title', 'Directory');
              // $('.floorplanBtn', nav).prop('title', 'Floorplan');
              $('.categoryBtn', nav).prop('title', 'Categories');

            }
    
        }
        navbar();

        function toggleFullScreen() {
            if ((document.fullScreenElement && document.fullScreenElement !== null) ||
                (!document.mozFullScreen && !document.webkitIsFullScreen)) {
                if (document.documentElement.requestFullScreen) {
                    document.documentElement.requestFullScreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullScreen) {
                    document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        }
    }

    
    function windowResizeHandler() {
        var offset;
        fpcHeight = elemById("floorplan").clientHeight;
        fpcWidth = elemById("floorplan").clientWidth;
        fpRight = data.viewportWidth - 2;
        fpBottom = data.viewportHeight - elemById( "ftr").offsetHeight;
        
        if( drawing !== null) {
            offset = drawing.resizeHandler();
            drawing.redraw( true);
        }
        if( miniMap) {
            miniMap.resize( offset);
        }
    }
    
    function fitDrawing() {
        drawing.fit();
    }

    function getLocation() {
        if ( navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition, showLocationError);
        }
        else {
            alert("Geolocation is not supported by this browser.");
        }
    }

    function showPosition(position) {
        
        drawing.clearIAmHere();

        var arFxCoords = gpsToFX(position.coords.latitude, position.coords.longitude)

        config.lastXY = arFxCoords;

        drawing.setIAmHere( String.fromCharCode(0xf140), "", arFxCoords[0],arFxCoords[1], config.clrHighlight);
        drawing.redraw(true);

        if( !config.locationEnabled){
            var bgColor = fxStyle.fpToolbar.clrBg !== "" ?
            fxStyle.fpToolbar.clrBg : fxStyle.floorplan.clrBg !== "" ?
            fxStyle.floorplan.clrBg : fxStyle.mainHeader.clrBg;

            var locationButton = elemById("tb6");
            locationButton.style.backgroundColor = bgColor;
            
            config.locationEnabled = true;

            locationTimeoutID = setInterval(getLocation, config.locationUpdateCheckInterval);
            
        }
        
    }

    function showLocationError(error) {
        switch(error.code) {
          case error.PERMISSION_DENIED:
            alert( "User denied the request for Geolocation.");
            break;
          case error.POSITION_UNAVAILABLE:
            alert( "Location information is unavailable.");
            break;
          case error.TIMEOUT:
            alert( "The request to get user location timed out.");
            break;
          case error.UNKNOWN_ERROR:
            alert( "An unknown error occurred.");
            break;
        }
      }

    function gpsToFX(latitude, longitude) {
        var coords;
        
        // Old values for testing based on my house :) -ANH
        var lat0 = parseFloat(config.refLat0); //41.700033;
        var lon0 = parseFloat(config.refLon0); //-88.341464;
        var lat1 = parseFloat(config.refLat1); //41.701947;
        var lon1 = parseFloat(config.refLon1); //-88.336517;
        
        var FXX0 = parseFloat(config.refFXX0); //1570.0;
        var FXY0 = parseFloat(config.refFXY0); //8375.0;
        var FXX1 = parseFloat(config.refFXX1); //16775.0;
        var FXY1 = parseFloat(config.refFXY1); //505.0;
    
        var radius = 110919.0;
        var d1 = (lat0 + lat1) / 2.0;
        var circumferenceAtLat = Math.cos(d1 * 0.01745329251) * 111305;
        var x0 = lon0 * circumferenceAtLat;
        var y0 = lat0 * radius;
        var x1 = lon1 * circumferenceAtLat;
        var y1 = lat1 * radius;

        if (false){ // Save the old code
            var d2 = (FXX1 - FXX0) / (x1 - x0);
            var d3 = (FXY1 - FXY0) / (y1 - y0);
    
            var x2 = longitude * circumferenceAtLat;
            var y2 = latitude * radius;
    
            var x = FXX0 + (x2 - x0) * d2;
            var y = FXY0 + (y2 - y0) * d3;
        }
        else{
            var d1 = x1 - x0;
            var d2 = y1 - y0;
            var d3 = Math.sqrt((d1 * d1) + (d2 * d2)); Math.sq
            var d4 = d2 / d3;
            var A1 = Math.asin(d4);		// Angle for GPS
        
            d1 = FXX1 - FXX0;
            d2 = FXY1 - FXY0;
            d3 = Math.sqrt((d1 * d1) + (d2 * d2));
            d4 = d2 / d3;
            var A2 = Math.asin(d4);		// Angle for FX
        
            var A3 = A1 - A2;
            var fx0 = FXX0;
            var fy0 = FXY0;
            var fx1 = fx0 + Math.cos(A3) * d1 - Math.sin(A3) * d2;		// rotate point to GPS
            var fy1 = fy0 + Math.sin(A3) * d1 + Math.cos(A3) * d2;
        
            d2 = (fx1 - fx0) / (x1 - x0);
            d3 = (fy1 - fy0) / (y1 - y0);
            A3 = A2 - A1;
        
            var x2 = longitude * circumferenceAtLat;
            var y2 = latitude * radius;
            
            x2 = x2 - x0;
            y2 = y2 - y0;
            var m1 = x2 * d2;
            var m2 = y2 * d3;	
        
            var x = fx0 + Math.cos(A3) * m1 - Math.sin(A3) * m2;		// rotate point to FX
            var y = fy0 + Math.sin(A3) * m1 + Math.cos(A3) * m2;
        }

        coords = [x, y];

        console.log("X: " + coords[0]);
        console.log("Y: " + coords[1]);
    
        return coords;
    }

    function show3d() {
        
        var ar;
        var tmp = drawing.getSelected();
        drawing.remove2d();
        if( threeD === null ) {    //  !threeD.getIsReady()
			threeD = new Drawing3d();
            drawing = threeD;
            drawing.completeSetup();
            drawing.addBuilding( buildingImage);
            markFavorites();
				//  only once 
			if( data.queryCoord !== "") {
				ar = data.queryCoord.split( ",");
				zoomToIAmHere( ar[0], ar[1], txt.I_AM_HERE);
			}
        }
        else {
            drawing = threeD;
        }
		
        drawing.showFloorPlan();
        drawing.updateSelected( tmp);
        twoD.removeAllSelected();
        if( miniMap) {
            miniMap.resize( drawing.getOffset());
        }
        tmp = null;
    }
    
    function show2d() {
        var ar;
        var tmp = drawing.getSelected();
        drawing.remove3dFloorPlan();
        if( !twoD.getIsReady() ) {
            drawing = twoD;
            drawing.completeSetup();
            drawing.addBuilding( buildingImage);
            markFavorites();
				//  only once ??
			if( data.queryCoord !== "") {
				ar = data.queryCoord.split( ",");
				zoomToIAmHere( ar[0], ar[1], txt.I_AM_HERE);
			}
        }
        else {
            drawing = twoD;
        }
        
		drawing.showFloorPlan();
        drawing.updateSelected( tmp);
        threeD.removeAllSelected();
        if( miniMap) {
            miniMap.resize( drawing.getOffset());
//            miniMap.enableNavigation();
        }
		drawing.redraw();
        tmp = null;
    }
    
        
    return {
        BOOTH_AVAILABLE : BOOTH_AVAILABLE,
        BOOTH_DELETED : BOOTH_DELETED,
        BOOTH_HOLD : BOOTH_HOLD,
        BOOTH_RENTED : BOOTH_RENTED,
        clearBooth : clearBooth,
        createBoothGradient: function( graphic) {
            return drawing.createBoothGradient( graphic);
        },
        getBoothColor : getBoothColor,
        getBoothMinMax : getBoothMinMax,
        getFloorPlanImage : function( full) {
            return drawing.getFloorPlanImage( full);
        },
		getFloorPlanPdf: function( value) {
			return drawing.drawPdf( value);		//  check drawing === 2D !!
		},
        init : init,
		is2d : function() {
			return (drawing === twoD);
		},
        globalToFloorPlan : function( pt) {
            return drawing.globalToFloorPlan(pt);
        },
        markFavorites : markFavorites,
        newBooth : newBooth,
        outlineBooth: outlineBooth,
        redraw : function() {
            drawing.redraw( true);
        },
        removeBoothText : removeBoothText,
        sales: sales,
        saveNewBooth: saveNewBooth,
        show2d: show2d,
        show3d: show3d,
        tagBooth : tagBooth,
        unOutlineBooth: unOutlineBooth,
        updateBooth : function() {
            drawing.redraw( true);
        },
        getLocation : getLocation,
        windowResizeHandler : windowResizeHandler,
        zoomToBoothIndex : zoomToBoothIndex,
        zoomToIAmHere : zoomToIAmHere,
        parseGraphicsSQL : parseGraphicsSQL, 
        createModal : createModal,
        switchDirectoryDialog : switchDirectoryDialog
    };
};